import {isStandardReaction} from '../../../../../core/helpers/reaction-display.helper';
import {Component, Input} from '@angular/core';
import {SwiperOptions} from 'swiper/types';
import {CurrentUserViewModel} from '../../../../../core/models/current-user.view-model';
import {ReactionListItemInterface} from '../../../../../core/interfaces/reaction-list-item.interface';
import {SocialDataProviderService} from '../../../../timeline/social-grid-list/social-data-provider.service';
import {SocialListItemRenderer} from '../social-list-item-renderer.interface';
import {UserViewModel} from '../../../../../features/user/settings/user.view-model';
import {SocialListReactionRemoval} from '../social-list-modal-config.interface';

@Component({
  selector: 'app-reaction-list-item',
  templateUrl: './reaction-list-item.component.html'
})
export class ReactionListItemComponent implements SocialListItemRenderer<ReactionListItemInterface> {
  @Input() public item: ReactionListItemInterface;
  @Input() public currentUser: CurrentUserViewModel;
  @Input() public socialDPS: SocialDataProviderService;
  @Input() public navigateTo: (item: ReactionListItemInterface) => void;
  @Input() public swiperConfig: SwiperOptions;
  @Input() public rendererInputs?: Record<string, unknown>;
  @Input() public reactionRemoval?: SocialListReactionRemoval;

  get canRemoveReaction(): boolean {
    return !!this.reactionRemoval && (!!this.currentUser?.['@id'] && this.item.author['@id'] === this.currentUser['@id']
      || !!this.currentUser?.id && this.item.author.apiModel?.id === this.currentUser.id);
  }

  public removeReaction(event: MouseEvent): void {
    event.stopPropagation();
    if (this.canRemoveReaction && !this.reactionRemoval.busy) this.reactionRemoval.remove();
  }

  get reactionLabelKey(): string {
    const reaction = this.item.reactedWith[0];
    return isStandardReaction(reaction) ? 'common.reaction.' + reaction.toLowerCase() : 'common.reaction.custom';
  }

  get showReactionIntent(): boolean {
    return !!this.rendererInputs?.showReactionIntent;
  }

  public isFollowedByCurrentUser(): boolean {
    return this.socialDPS.isFollowedByCurrentUser(this.item.author as unknown as UserViewModel);
  }

  public isLikedByCurrentUser(): boolean {
    return this.socialDPS.isLikedByCurrentUser(this.item.author as unknown as UserViewModel);
  }
}
